var image_upload_default = {
  "container": "kkJVj",
  "disabled": "fvkES",
  "imageInput": "na4p4",
  "overlay": "DOOgu",
  "text": "_6bdm-",
  "shown": "kg2Oc",
  "hide": "YPP6w",
  "spinner": "ZcbI3",
  "spin": "_5MWic"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
